<template lang="pug">
  #modalProductComponent
    transition(name='modal' @click.prevent.self='')
      .modal-mask(v-if='product' v-on:click.stop='closeModal')
        .modal-wrapper.modal-container-combo(v-if='product.combo_id')
          .modal-container
            .productImage
              .product-image
                .media
                  img(:src='product.image_url || imageDefaultCombo' alt='' onerror="this.src = '../assets/images/default_combo.png'")
            .productAddToCart
              .quantity
                span.label Số lượng:
                span.btn-quantity.minus(v-on:click='minusQuantity')
                span.number {{orderItem.Quantity}}
                span.btn-quantity.plus(v-on:click='plusQuantity')
              .btnAdd(v-on:click='updateCart')
                span Thêm vào giỏ
                | {{orderItem}}
                span.price
                  i.fa.fa-shopping-bag(aria-hidden='true')
                  | +{{(orderItem.Price + orderItem.plusPrice) * orderItem.Quantity | formatPrice}}
            .productInfomattion
              .productOptions
                .group(v-for='(comboItem,key) in orderItem.options ')
                  .optionGroupName.case1
                    h3 Nhóm
                    span Bắt buộc
                  .optionItems
                    .item(v-for='cbdetail in comboItem.details')
                      input(type='radio' :id='cbdetail.Item_Id' :value='cbdetail.Item_Id' v-model='comboItem.selected')
                      label(:for='cbdetail.Item_Id') {{cbdetail.Item_Name}}
            slot
        .modal-wrapper(v-else)
          .modal-container
            slot
            .productInfomattion
              .product-image
                .media
                  img(:src='product.image_url || imageDefault' alt='' onerror="this.src = '../assets/images/default.png'")
              .product-info
                .productDesc
                  .name
                    h3 {{product.name}}
                .productOptions
                  .group(v-if='product.childs')
                    .optionGroupName
                      h3 Size
                    .optionItems
                      .item(v-for='size in product.childs' v-if="size.status !== 'DEACTIVE'")
                        input(type='radio' :id='size.store_item_id' :value='size.store_item_id' v-model='orderItem.Item_Id' v-on:change='selectProduct(size)')
                        label(:for='size.store_item_id')
                          | {{size.name}}
                          span(v-if='size.ta_price') ({{ size.ta_price | formatPrice }})
                  .group(v-if='product.customizations' v-for='productOption in product.customizations')
                    .optionGroupName
                      h3 {{productOption.name}}
                      span.note
                        template(v-if="productOption.min_permitted === productOption.max_permitted && productOption.max_permitted ===1")
                          | *Đã chọn {{ orderItem.options[productOption.id].options ? orderItem.options[productOption.id].options.length : 0 }} / {{ productOption.max_permitted }}
                        template(v-else='')
                          template(:class="{'is-warning': orderItem.options[productOption.id].count < productOption.max_permitted}")
                            | *Đã chọn {{ orderItem.options[productOption.id].count ? orderItem.options[productOption.id].count : 0 }}
                          template(v-if='productOption.max_permitted > 0')
                            |  /{{ productOption.max_permitted  }}
                    .optionItems(v-if='productOption.options')
                      .item(v-for='(option,key) in productOption.options' :class="{'multi': !(productOption.max_permitted === 1 &&  productOption.min_permitted === 1) }")
                        template(v-if='productOption.min_permitted === 1 && productOption.max_permitted === 1 ')
                          input(type='radio' :id='option.id' :value='[option.name]' v-model='orderItem.options[productOption.id].options' @change='calculatePrice(productOption.id,option,key)')
                          label(:for='option.id')
                            | {{option.name}}
                            span(v-if='option.ta_price') (+{{ option.ta_price | formatPrice }})
                        template(v-else)
                          .option
                            span.option-qty(:class="[{'is-active': isOptionActive(productOption.id, key) },{'is-disabled': isOptionDisabled(productOption.id, key)}]" @click="onClickOption(productOption.id,key)")
                              svg(width='18' height='18' viewbox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg')
                                path(d='M15 0C16.6569 0 18 1.34315 18 3V15C18 16.6569 16.6569 18 15 18H3C1.34315 18 0 16.6569 0 15V3C0 1.34315 1.34315 0 3 0H15ZM13.4697 4.96967L7 11.4393L4.53033 8.9697C4.23744 8.6768 3.76256 8.6768 3.46967 8.9697C3.17678 9.2626 3.17678 9.7374 3.46967 10.0303L6.46967 13.0303C6.76256 13.3232 7.2374 13.3232 7.5303 13.0303L14.5303 6.03033C14.8232 5.73744 14.8232 5.26256 14.5303 4.96967C14.2374 4.67678 13.7626 4.67678 13.4697 4.96967Z' fill='#BC2030')
                            span.option-label
                              | {{option.name}}
                              span(v-if='option.ta_price') (+{{ option.ta_price | formatPrice }})
                            span.option-quantity(v-if="orderItem.options[productOption.id].model[key].quantity")
                              button(@click.prevent="changeOptionQuantity(productOption.id,key,'minus')" :disabled="orderItem.options[productOption.id].model[key].quantity <= 1")
                                svg(width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
                                  path(d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill='#BC2030')
                                  path(d='M17.3333 11.3333C17.6752 11.3333 17.957 11.5906 17.9955 11.9222L18 12C18 12.3418 17.7427 12.6236 17.4111 12.6622L17.3333 12.6666C11.0503 12.6666 13.3453 12.6666 6.66667 12.6666C6.32477 12.6666 6.04299 12.4093 6.00449 12.0777L6 12C6 11.6581 6.25736 11.3763 6.58892 11.3378L6.66667 11.3333C13.189 11.3333 10.3736 11.3333 17.3333 11.3333Z' fill='white')

                              span.option-quantity__number {{ orderItem.options[productOption.id].model[key].quantity }}
                              button(@click.prevent="changeOptionQuantity(productOption.id,key,'plus')" :disabled="(orderItem.options[productOption.id].max - orderItem.options[productOption.id].count) <= 0")
                                svg(width='24' height='24' viewbox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg')
                                  path(d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill='#BC2030')
                                  path(d='M11.9223 6.00449L12 6C12.3419 6 12.6237 6.25736 12.6622 6.58892L12.6667 6.66667V11.3333H17.3333C17.6752 11.3333 17.957 11.5907 17.9955 11.9223L18 12C18 12.3419 17.7427 12.6237 17.4111 12.6622L17.3333 12.6667H12.6667V17.3333C12.6667 17.6752 12.4093 17.957 12.0777 17.9955L12 18C11.6581 18 11.3763 17.7427 11.3378 17.4111L11.3333 17.3333V12.6667H6.66667C6.32477 12.6667 6.04299 12.4093 6.00449 12.0777L6 12C6 11.6581 6.25736 11.3763 6.58892 11.3378L6.66667 11.3333H11.3333V6.66667C11.3333 6.32477 11.5907 6.04299 11.9223 6.00449L12 6L11.9223 6.00449Z' fill='white')

                .productNote
                  .inner
                    svg(class="icon-svg-note" width='18' height='18' viewbox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg')
                      path(d='M14.75 0C16.5449 0 18 1.45507 18 3.25V10H13.25C11.4551 10 10 11.4551 10 13.25V18H3.25C1.45507 18 0 16.5449 0 14.75V3.25C0 1.45507 1.45507 0 3.25 0H14.75ZM17.56 11.5L11.5 17.56V13.25C11.5 12.2835 12.2835 11.5 13.25 11.5H17.56Z' fill='#ADA8A8')

                    input(placeholder='Thêm ghi chú món này' v-model='orderItem.Note')
                .productAddToCart
                  .quantity-wrapper
                    span.label Số lượng
                    .quantity
                      span.btn-quantity.minus(v-on:click='minusQuantity')
                      span.number {{orderItem.Quantity}}
                      span.btn-quantity.plus(v-on:click='plusQuantity')
                  .btnAdd(v-on:click='updateCart')
                    span.is-desktop Thêm vào giỏ
                    span.is-mobile Thêm
                    span.price
                      | +{{ (orderItem.Price + orderItem.plusPrice) * orderItem.Quantity | formatPrice}}
</template>

<script>
  import CartQuantity from './CartQuantity'

  export default {
    name: 'ModalProduct',
    props: ['product', 'active', 'activeId', 'order'],
    components: {
      CartQuantity
    },
    data() {
      let options = {};

      if (this.product.customizations != null && this.product.customizations.length > 0) {
        for (let i = 0; i < this.product.customizations.length; i++) {
          this.product.customizations[i].id = i;
        }
      }
      _.forEach(this.product.customizations, (option, index) => {
        let _arr = option.options, _options = []
        if (_arr) {
          _.forEach(_arr, opt => {
            _options.push({
              id: opt.id,
              name: opt.name,
              price: opt.ta_price,
              quantity: 0,
            })
          })
        }
        options[option.id] = {
          name: option.name,
          count: 0,
          max: parseInt(option.max_permitted),
          min: parseInt(option.min_permitted),
          options: [],
          model: _options
        }
      });
      if (!this.order) {
        if (this.product.combo_id) {
          return {
            //Order
            orderItem: {
              Item_Type_Id: "",
              Item_Id: this.product.combo_id,
              Item_Name: this.product.combo_name,
              Price: this.product.ta_price,
              Quantity: 1,
              Note: "",
              Discount: 0,
              Foc: 0,
              Package_Id: this.product.id,
              Fix: 1,
              options: _.merge([], this.product.combo_details),
              plusPrice: 0,
              isCombo: 1
            },
            imageDefault: this.$foodbookConfig.imageDefault,
            imageDefaultCombo: this.$foodbookConfig.imageDefaultCombo,
          };
        } else {
          return {
            //Order
            orderItem: {
              Item_Type_Id: "",
              Item_Id: this.product.store_item_id,
              Item_Name: this.product.name,
              Price: this.product.ta_price,
              Quantity: 1,
              Note: "",
              Discount: 0,
              Foc: 0,
              Fix: 0,
              options: options,
              plusPrice: 0
            },
            imageDefault: this.$foodbookConfig.imageDefault,
            imageDefaultCombo: this.$foodbookConfig.imageDefaultCombo,
          };
        }
      } else {
        //console.info('Đã tồn tại đơn')
        return {
          //Order
          orderItem: this.order,
          imageDefault: this.$foodbookConfig.imageDefault,
          imageDefaultCombo: this.$foodbookConfig.imageDefaultCombo
        }
      }

    },
    created() {

      document.getElementsByTagName('html')[0].classList.add('no-scrollbar')

    },
    destroyed() {
      document.getElementsByTagName('html')[0].classList.remove('no-scrollbar')
    },
    methods: {
      closeModal(event) {
        if (event.target === event.currentTarget) this.$emit('close')
      },
      minusQuantity() {
        if (this.orderItem.Quantity > 1) this.orderItem.Quantity--;
      },
      plusQuantity() {
        this.orderItem.Quantity++;
      },

      // tính toán giá khi chọn các option
      calculatePrice() {
        const customizations = this.orderItem.options
        let amount = 0;
        if (customizations) {
          _.forOwn(customizations, customization => {
            if (customization.model) {
              _.forEach(customization.model, option => {
                if (option.quantity > 0) {
                  amount = amount + (option.quantity * option.price)
                } else {
                  if (customization.options && customization.options.includes(option.name)) {
                    amount = amount + (option.price) // lúc này quantity = 1
                  }
                }
              })
            }
          })
        }
        this.orderItem.plusPrice = amount
      },
      calcularPlusPrice(option, key) {
        //console.log(option.name);
        //console.log(this.orderItem.options[key].options);
        let flag = false;
        if (this.orderItem.options[key].options != null && this.orderItem.options[key].options.length > 0) {
          for (let i = 0; i < this.orderItem.options[key].options.length; i++) {

            if (this.orderItem.options[key].options[i] == option.name) {
              flag = true;
            }
          }
        }
        if (!flag) {
          console.log("tim khong ra");
          this.orderItem.plusPrice -= option.ta_price;
        } else {
          console.log("tim +");
          this.orderItem.plusPrice += option.ta_price;
        }
        /*
        if (this.orderItem.options[key].options.indexOf(option.name) == -1) {
            console.log("tim khong ra");
            this.orderItem.plusPrice -= option.ta_price;
        } else {
            console.log("tim +");
            this.orderItem.plusPrice += option.ta_price;
        }*/
      },
      selectProduct(product) {
        this.orderItem.Item_Name = product.name;
        this.orderItem.Price = product.ta_price;
      },
      selectComboProduct(product) {

      },
      updateCart() {
        //Check require option
        let error = false;
        if (this.orderItem.isCombo) {
          _.forEach(this.orderItem.options, (value, key) => {
            if (value.quantity) {
              if (!value.selected) {
                error = true;
                this.$toasted.show("Vui lòng chọn món trong nhóm " + key, {
                  position: "top-center",
                  duration: 15000,
                  type: 'error'
                });
              }
            }


          });
          if (!error) {
            this.$emit('updateCart', this.orderItem, this.product, this.activeId);
          }
        } else {
          _.forEach(this.orderItem.options, (value, key) => {
            //console.log('!isCombo', value);
            console.log(value.count)
            if (value.min == 1) { // trường hợp UI là radio button
              if (value.options.length < value.min) {
                error = true;
                this.$toasted.show("Vui lòng chọn " + value.name, {
                  position: "top-center",
                  duration: 5000,
                  type: 'error'
                });
              }
            } else { // trường hợp UI là chọn nhiều
              if (value.count < value.min) {
                error = true;
                this.$toasted.show("Vui lòng chọn " + value.name, {
                  position: "top-center",
                  duration: 5000,
                  type: 'error'
                });
              }
            }
            if (value.max == 1) {
              if (value.options.length > value.max) {
                error = true;
                this.$toasted.show("Bạn chọn quá nhiều " + value.name, {
                  position: "top-center",
                  duration: 5000,
                  type: 'error'
                });
              }
            } else {
              if (value.count > value.max) {
                error = true;
                this.$toasted.show("Bạn chọn quá nhiều " + value.name, {
                  position: "top-center",
                  duration: 5000,
                  type: 'error'
                });
              }
            }
          });
          //Check size require
          if (this.product.childs) {
            if (this.orderItem.Item_Id === this.product.store_item_id) {
              error = true;
              this.$toasted.show("Please select a product type (size)", {
                position: "top-center",
                duration: 5000,
                type: 'error'
              });
            }
          }
          console.log('this.orderItem', this.orderItem);
          console.log('this.product', this.product);
          if (!error) {
            this.$emit('updateCart', this.orderItem, this.product, this.activeId);
          }
        }
      },
      changeOptionQuantity(selectionId, optionIndex, action = 'plus') {
        if (!this.orderItem.options[selectionId].model[optionIndex]) return false;

        if ('plus' === action) {
          if (this.orderItem.options[selectionId].count < this.orderItem.options[selectionId].max) {
            this.orderItem.options[selectionId].model[optionIndex].quantity++;
            this.orderItem.options[selectionId].count++;
          }
        } else if ('minus' === action) {
          if (this.orderItem.options[selectionId].model[optionIndex].quantity > 0) {
            this.orderItem.options[selectionId].model[optionIndex].quantity--
            this.orderItem.options[selectionId].count--
            if (this.orderItem.options[selectionId].count <0) this.orderItem.options[selectionId].count = 0
          }
        } else if ('selected === action') {

        }
        return this.calculatePrice()

      },
      removeOption(selectionId, optionIndex) {
        let n = this.orderItem.options[selectionId].model[optionIndex].quantity;
        if (n > 0) {
          this.orderItem.options[selectionId].count = this.orderItem.options[selectionId].count - n;
          this.orderItem.options[selectionId].model[optionIndex].quantity = 0;
        }
        return this.calculatePrice()
      },

      isOptionActive (optionId, modelKey) {
        return this.orderItem ? this.orderItem.options[optionId].model[modelKey].quantity > 0 : null;
      },
      isOptionDisabled (optionId, modelKey) {
        return this.orderItem.options[optionId].count >= this.orderItem.options[optionId].max && this.orderItem.options[optionId].model[modelKey].quantity === 0
      },
      onClickOption(optionId,k) {
        let option = this.orderItem.options[optionId];
        if (!option) return;
        if (option.model[k].quantity === 0) {
          if (option.count >= option.max) return // trường hợp ko còn đặt đc
          this.orderItem.options[optionId].count++;
          this.orderItem.options[optionId].model[k].quantity = 1
          return this.calculatePrice()
        }

        if (option.model[k].quantity > 0) {
          this.removeOption(optionId,k)
        }

      },

    } // methods
  }
</script>



// WEBPACK FOOTER //
// src/components/ModalProduct.vue